import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData } from '@components/ssap/SsapTypes';

interface ITruthAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    formName: string,
    isAsteriskShown: boolean,
    isFinancialFlow: boolean
}


const TruthAttestation = (props: ITruthAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                isTruthful
            }
        },
        formName,
        isAsteriskShown = true,
        isFinancialFlow
    } = props;

    const classname = classnames({
        'required-true': isAsteriskShown
    });

    const getTextReplacement = (): React.ReactNode => {
        switch(true) {
            case isFinancialFlow:
                return (
                    <span className = { classname } >
                        <FormattedMessage id = 'ssap.sign_and_review.is_truthful_ff' />
                    </span>
                );
            default:
                return (
                    <span className = { classname }>
                        <FormattedMessage
                            id = 'ssap.sign_and_review.is_truthful'
                            values = { { lineBreak: <br /> } }
                        />
                    </span>
                );
        }
    };

    return (
        <UniversalInput
            label = { {
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: getTextReplacement()
                }
            } }
            inputData = { {
                isInputRequired: true,
                classes: [ 'disp-styl' ],
                type: INPUT_TYPES.CHECKBOX,
                name: 'isTruthful',
                checked: isTruthful,
                value: isTruthful,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'legalAttestations' ]
            } }
            errorClasses={ [ 'margin-l-0' ] }
            inputActions={ {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default TruthAttestation;